// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ece86f53","455":"de1a7204","644":"a62747b4"}[chunkId] + ".chunk.js";
};